module.exports = function(obj){
var __t,__p='',__j=Array.prototype.join,print=function(){__p+=__j.call(arguments,'');};
with(obj||{}){
__p+='\n<!-- src/app/employer/templates/reports/Filters.ejs -->\n<form class="filters row form-inline m-t-md m-b-md">\n    <div class="form-group m-t-sm m-l-md">\n        <label class="m-r-sm">Date Range</label>\n        <select class="form-control js-date-range" name="dateRange">\n            <option value="" '+
((__t=( !filters.dateRange ? 'selected' : '' ))==null?'':_.escape(__t))+
'>\n                Custom Date\n            </option>\n            ';
 _.each(dateRanges, function(range, key) { 
__p+='\n            <option value="'+
((__t=( key ))==null?'':_.escape(__t))+
'"\n                data-from="'+
((__t=( range.from ))==null?'':_.escape(__t))+
'"\n                data-to="'+
((__t=( range.to ))==null?'':_.escape(__t))+
'"\n                '+
((__t=( filters.dateRange === key ? 'selected': '' ))==null?'':_.escape(__t))+
'>\n                '+
((__t=( range.label ))==null?'':_.escape(__t))+
'\n            </option>\n            ';
 }) 
__p+='\n        </select>\n        <div class="input-daterange input-group js-datepicker-range">\n            <input class="form-control js-datepicker-from" name="from"\n                value="'+
((__t=( filters.fromFormatted ))==null?'':_.escape(__t))+
'"\n                '+
((__t=( filters.dateRange ? 'disabled': '' ))==null?'':_.escape(__t))+
'>\n            <span class="input-group-addon">to</span>\n            <input class="form-control js-datepicker-to" name="to"\n                value="'+
((__t=( filters.toFormatted ))==null?'':_.escape(__t))+
'"\n                '+
((__t=( filters.dateRange ? 'disabled': '' ))==null?'':_.escape(__t))+
'>\n        </div>\n    </div>\n\n    <div class="form-group m-t-sm m-l-md">\n        <label class="m-r-sm">Group By</label>\n        <select class="form-control js-group-by">\n            ';
 groupBy.forEach(function(element) { 
__p+='\n                <option value="'+
((__t=( element.toLowerCase() ))==null?'':_.escape(__t))+
'"\n                    '+
((__t=( filters.groupBy === element.toLowerCase() ? 'selected': ''))==null?'':_.escape(__t))+
'>\n                    '+
((__t=( element ))==null?'':_.escape(__t))+
'\n                </option>\n            ';
 }) 
__p+='\n        </select>\n        <div class="form-group">\n            <select name="group" class="form-control chosen-select"\n                multiple data-placeholder="All">\n                ';
 group.forEach(function(element) { 
__p+='\n                    <option value="'+
((__t=( element.id ))==null?'':_.escape(__t))+
'"\n                        '+
((__t=( _.contains(filters['group[]'], element.id) ? 'selected': '' ))==null?'':_.escape(__t))+
'>\n                        '+
((__t=( element.title ))==null?'':_.escape(__t))+
'\n                    </option>\n                ';
 }) 
__p+='\n            </select>\n        </div>\n    </div>\n    <div class="form-group m-t-sm m-l-md">\n        <label class="m-r-sm">Type of Report</label>\n        <select class="form-control js-type">\n            ';
 types.forEach(function(type) { 
__p+='\n                <option value="'+
((__t=( type ))==null?'':_.escape(__t))+
'"\n                    '+
((__t=( filters.type === type ? 'selected': '' ))==null?'':_.escape(__t))+
'>\n                    '+
((__t=( type ))==null?'':_.escape(__t))+
'\n                </option>\n            ';
 }) 
__p+='\n        </select>\n        <div class="form-group m-l-lg">\n            <button type="submit" class="btn btn-primary">\n                <i class="fa fa-refresh"></i>\n            </button>\n        </div>\n    </div>\n</form>\n';
}
return __p;
};



//////////////////
// WEBPACK FOOTER
// ./app/employer/templates/reports/Filters.ejs
// module id = 824
// module chunks = 1